import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'motion',
  initialState: {
    enabled: false,
    loading: false,
    error: null,
    byDeviceId: {},
    lastSync: null,
  },
  reducers: {
    setEnabled(state, action) {
      state.enabled = action.payload;
    },
    requestStart(state) {
      state.loading = true;
      state.error = null;
    },
    requestSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.lastSync = Date.now();
      action.payload.forEach((item) => {
        if (item?.deviceId) {
          state.byDeviceId[item.deviceId] = item;
        }
      });
    },
    requestFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export { actions as motionActions };
export { reducer as motionReducer };
